import { withIcon } from "../Icon"

export const IconCopy = withIcon(
  '<path fill="currentColor" d="M19.333 4H8.667A.667.667 0 0 0 8 4.667V8H4.667A.667.667 0 0 0 4 8.667v10.666a.667.667 0 0 0 .667.667h10.666a.666.666 0 0 0 .667-.667V16h3.333a.666.666 0 0 0 .667-.667V4.667A.666.666 0 0 0 19.333 4Zm-4.666 14.667H5.333V9.333h9.334v9.334Zm4-4H16v-6A.666.666 0 0 0 15.333 8h-6V5.333h9.334v9.334Z"/>',
)
